var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTakhaloph({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 15.2194H10.35L6.56749 17.8499C6.00649 18.2409 5.25 17.8233 5.25 17.1123V15.2194C2.7 15.2194 1 13.442 1 10.7758V5.44354C1 2.77741 2.7 1 5.25 1H13.75C16.3 1 18 2.77741 18 5.44354V10.7758C18 13.442 16.3 15.2194 13.75 15.2194Z",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96875 9.5V9.3017C8.96875 8.65948 9.37202 8.31947 9.77526 8.04558C10.1689 7.78113 10.5625 7.44114 10.5625 6.81781C10.5625 5.94892 9.85205 5.25 8.96875 5.25C8.08545 5.25 7.375 5.94892 7.375 6.81781",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96397 12.1562H8.97353",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakhaloph);
export default __webpack_public_path__ + "static/media/takhaloph.ed1430cd58e6df09f5061133d70a3111.svg";
export { ForwardRef as ReactComponent };